<script>
import FormTemplatesFormSheet from '@/views/FormTemplates/components/FormTemplatesFormSheet.vue'
import { createDefaultData as createDefaultDataCell } from './PassportTemplatesCell.vue'

export const createDefaultData = (code, uuid, uuid2) => ({
  uuid,
  code: `sheet$${code}`,
  name: `Лист ${code}`,
  vertical: false,
  cells: [createDefaultDataCell(1, uuid2)],
})

export default {
  name: 'PassportTemplatesSheet',
  extends: FormTemplatesFormSheet,
}
</script>
